// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Sidebar.css — the sliding active indicator.
 *
 * WHAT CHANGED AND WHY
 *
 * The active section used to be painted directly on each .nav-item: a gradient
 * background plus a 3px rail from \`.nav-item.active::before\`. Switching section
 * therefore snapped — one item's background disappeared and another's appeared
 * in the same frame, with nothing connecting them.
 *
 * Now a single \`.nav-slider\` element carries that treatment and is animated
 * between items, so the selection visibly travels. The per-item background and
 * rail are suppressed below; the active item keeps only its colour change,
 * which cross-fades naturally.
 *
 * Loaded after index.css (imported from Sidebar.jsx), and every override is
 * scoped under \`.sidebar-nav\` so it outranks the bare \`.nav-item\` rules there
 * without needing !important.
 */

/* The indicator is absolutely positioned, so the nav has to be its containing
   block. Note \`.sidebar\` is position:fixed, which is what \`.nav-item.active
   ::before\` was previously resolving against — hence the rail's slightly odd
   placement. Anchoring to the nav makes the geometry explicit. */
.sidebar .sidebar-nav {
  position: relative;
}

.sidebar-nav .nav-slider {
  position: absolute;
  /* Inset to match .sidebar-nav's own 12px horizontal padding, so the pill
     lines up exactly with the items rather than spanning the full nav. */
  left: 12px;
  right: 12px;
  top: 0;
  z-index: 0;
  pointer-events: none;

  border-radius: var(--radius-md, 10px);
  background: linear-gradient(
    135deg,
    rgba(139, 92, 246, 0.14),
    rgba(124, 58, 237, 0.08)
  );
  /* The rail, now part of the moving element instead of a separate ::before. */
  box-shadow: inset 3px 0 0 0 var(--accent-primary, #8b5cf6);
}

/* Transition is applied only once the indicator has been placed. Without this
   gate it animates from translateY(0) on first paint — the selection appears
   to fly in from the top of the sidebar on every page load.
   \`height\` is transitioned too, because rows differ slightly in height when the
   sidebar collapses. */
.sidebar-nav .nav-slider--primed {
  transition:
    transform 260ms cubic-bezier(0.22, 0.61, 0.36, 1),
    height 260ms cubic-bezier(0.22, 0.61, 0.36, 1);
}

/* Items sit above the indicator so their label and icon stay legible. */
.sidebar-nav .nav-item {
  position: relative;
  z-index: 1;
  /* Colour only. \`transition: all\` in index.css would animate background and
     box-shadow too, fighting the indicator during the slide. */
  transition:
    color 160ms cubic-bezier(0.22, 0.61, 0.36, 1),
    background-color 160ms cubic-bezier(0.22, 0.61, 0.36, 1);
}

/* The moving indicator now supplies the active background and rail, so the
   per-item versions are suppressed — otherwise the destination lights up
   instantly and there is nothing left to slide toward. */
.sidebar-nav .nav-item.active {
  background: transparent;
  color: var(--accent-primary, #8b5cf6);
}

.sidebar-nav .nav-item.active::before {
  content: none;
}

/* Hover stays, but must not read as selection. Kept below the active colour so
   hovering an inactive item is legible without competing with the indicator. */
/* .sidebar-nav .nav-item:hover {
  background: var(--bg-secondary);
  color: var(--text-primary);
} */

.sidebar-nav .nav-item.active:hover {
  background: transparent;
  color: var(--accent-primary, #8b5cf6);
}

/* Keyboard focus has to remain visible on top of the indicator. */
.sidebar-nav .nav-item:focus-visible {
  outline: 2px solid var(--accent-primary, #8b5cf6);
  outline-offset: -2px;
  border-radius: var(--radius-md, 10px);
}

/* Collapsed rail: the pill shrinks to the icon column, so it is inset less. */
.sidebar.collapsed .sidebar-nav .nav-slider {
  left: 8px;
  right: 8px;
}

/* Vestibular safety, and an honest fallback: with motion reduced the indicator
   still MOVES (it must, or the active item would be unmarked) — it just jumps
   instead of travelling. */
@media (prefers-reduced-motion: reduce) {
  .sidebar-nav .nav-slider--primed {
    transition: none;
  }

  .sidebar-nav .nav-item {
    transition: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/layout/Sidebar.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;EAiBE;;AAEF;;;iEAGiE;AACjE;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB;yEACuE;EACvE,UAAU;EACV,WAAW;EACX,MAAM;EACN,UAAU;EACV,oBAAoB;;EAEpB,qCAAqC;EACrC;;;;GAIC;EACD,6EAA6E;EAC7E,0DAA0D;AAC5D;;AAEA;;;;uBAIuB;AACvB;EACE;;kDAEgD;AAClD;;AAEA,wEAAwE;AACxE;EACE,kBAAkB;EAClB,UAAU;EACV;+DAC6D;EAC7D;;4DAE0D;AAC5D;;AAEA;;yDAEyD;AACzD;EACE,uBAAuB;EACvB,qCAAqC;AACvC;;AAEA;EACE,aAAa;AACf;;AAEA;+EAC+E;AAC/E;;;GAGG;;AAEH;EACE,uBAAuB;EACvB,qCAAqC;AACvC;;AAEA,kEAAkE;AAClE;EACE,iDAAiD;EACjD,oBAAoB;EACpB,qCAAqC;AACvC;;AAEA,8EAA8E;AAC9E;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;;2BAE2B;AAC3B;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":["/* Sidebar.css — the sliding active indicator.\n *\n * WHAT CHANGED AND WHY\n *\n * The active section used to be painted directly on each .nav-item: a gradient\n * background plus a 3px rail from `.nav-item.active::before`. Switching section\n * therefore snapped — one item's background disappeared and another's appeared\n * in the same frame, with nothing connecting them.\n *\n * Now a single `.nav-slider` element carries that treatment and is animated\n * between items, so the selection visibly travels. The per-item background and\n * rail are suppressed below; the active item keeps only its colour change,\n * which cross-fades naturally.\n *\n * Loaded after index.css (imported from Sidebar.jsx), and every override is\n * scoped under `.sidebar-nav` so it outranks the bare `.nav-item` rules there\n * without needing !important.\n */\n\n/* The indicator is absolutely positioned, so the nav has to be its containing\n   block. Note `.sidebar` is position:fixed, which is what `.nav-item.active\n   ::before` was previously resolving against — hence the rail's slightly odd\n   placement. Anchoring to the nav makes the geometry explicit. */\n.sidebar .sidebar-nav {\n  position: relative;\n}\n\n.sidebar-nav .nav-slider {\n  position: absolute;\n  /* Inset to match .sidebar-nav's own 12px horizontal padding, so the pill\n     lines up exactly with the items rather than spanning the full nav. */\n  left: 12px;\n  right: 12px;\n  top: 0;\n  z-index: 0;\n  pointer-events: none;\n\n  border-radius: var(--radius-md, 10px);\n  background: linear-gradient(\n    135deg,\n    rgba(139, 92, 246, 0.14),\n    rgba(124, 58, 237, 0.08)\n  );\n  /* The rail, now part of the moving element instead of a separate ::before. */\n  box-shadow: inset 3px 0 0 0 var(--accent-primary, #8b5cf6);\n}\n\n/* Transition is applied only once the indicator has been placed. Without this\n   gate it animates from translateY(0) on first paint — the selection appears\n   to fly in from the top of the sidebar on every page load.\n   `height` is transitioned too, because rows differ slightly in height when the\n   sidebar collapses. */\n.sidebar-nav .nav-slider--primed {\n  transition:\n    transform 260ms cubic-bezier(0.22, 0.61, 0.36, 1),\n    height 260ms cubic-bezier(0.22, 0.61, 0.36, 1);\n}\n\n/* Items sit above the indicator so their label and icon stay legible. */\n.sidebar-nav .nav-item {\n  position: relative;\n  z-index: 1;\n  /* Colour only. `transition: all` in index.css would animate background and\n     box-shadow too, fighting the indicator during the slide. */\n  transition:\n    color 160ms cubic-bezier(0.22, 0.61, 0.36, 1),\n    background-color 160ms cubic-bezier(0.22, 0.61, 0.36, 1);\n}\n\n/* The moving indicator now supplies the active background and rail, so the\n   per-item versions are suppressed — otherwise the destination lights up\n   instantly and there is nothing left to slide toward. */\n.sidebar-nav .nav-item.active {\n  background: transparent;\n  color: var(--accent-primary, #8b5cf6);\n}\n\n.sidebar-nav .nav-item.active::before {\n  content: none;\n}\n\n/* Hover stays, but must not read as selection. Kept below the active colour so\n   hovering an inactive item is legible without competing with the indicator. */\n/* .sidebar-nav .nav-item:hover {\n  background: var(--bg-secondary);\n  color: var(--text-primary);\n} */\n\n.sidebar-nav .nav-item.active:hover {\n  background: transparent;\n  color: var(--accent-primary, #8b5cf6);\n}\n\n/* Keyboard focus has to remain visible on top of the indicator. */\n.sidebar-nav .nav-item:focus-visible {\n  outline: 2px solid var(--accent-primary, #8b5cf6);\n  outline-offset: -2px;\n  border-radius: var(--radius-md, 10px);\n}\n\n/* Collapsed rail: the pill shrinks to the icon column, so it is inset less. */\n.sidebar.collapsed .sidebar-nav .nav-slider {\n  left: 8px;\n  right: 8px;\n}\n\n/* Vestibular safety, and an honest fallback: with motion reduced the indicator\n   still MOVES (it must, or the active item would be unmarked) — it just jumps\n   instead of travelling. */\n@media (prefers-reduced-motion: reduce) {\n  .sidebar-nav .nav-slider--primed {\n    transition: none;\n  }\n\n  .sidebar-nav .nav-item {\n    transition: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
